/** @format */

module.exports = {
  publicKey: "ac86f739529b1832e4122dec6e0f2731",
  hostnameId: "speedycasino",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js